import { GetServerSideProps } from 'next'
import React from 'react'

import { CMSPage } from '@Components/CMS/Page'
import { Page, PageType } from '@Generated/graphql'
import { initializeApolloFromContext } from '@Globals/Apollo/Server'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { PageHOC } from '@Globals/Page/Client'
import { boostFromContext, pageProps } from '@Globals/Page/Server'
import { PageProps } from '@Globals/Page/Types'
import { getSinglePostByID } from '@Queries/cms/SinglePost.query'

interface FrontpagesProps extends PageProps {
  item: Page
}

export const getServerSideProps: GetServerSideProps<FrontpagesProps> = async (context) => {
  const apolloClient = initializeApolloFromContext(context)
  const id = '149'
  const post = await getSinglePostByID(
    apolloClient,
    PageType.Frontpage,
    id,
    undefined,
    boostFromContext(context),
    context?.req?.thSplitTests,
  )
  const { page } = post.data

  if (!page) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      ...await pageProps(
        context,
        { type: 'frontpages', id },
        page,
        ['cart', 'common', 'cms', 'footer', 'header', 'sidebar', 'validation', 'shipping', 'products', 'club'],
      ),
      item: page as Page,
    },
  }
}

const Home = PageHOC<FrontpagesProps>(({ item }) => {
  const components = useBlockComponents(item.blocks || [])

  return (
    <CMSPage>
      {components}
    </CMSPage>
  )
})

export default Home
